import MicroModal from 'micromodal';

export default new class Modal {
    constructor() {
        this.modal ='modal-phone';
        this.trigger = 'triggers__phone';
        this.formSelector = 'modal-form';
        this.inValidSelector = '_invalid';
        this.modalFormInputSelector = 'modal-form__input';
        this.sendSuccessSelector = 'modal__success';
        this.preLoaderSelector = 'modal-form__preloader';

        this.handler();
    }

    handler() {
        const form = document.querySelector(`.${this.formSelector}`);
        const trigger = document.querySelector(`.${this.trigger}`);


        document.addEventListener('DOMContentLoaded', () => {

            trigger.addEventListener('click', (event)=>{
                event.preventDefault();
            })

            MicroModal.init({
                disableScroll: true,
                awaitOpenAnimation: true,
                awaitCloseAnimation: true,
            });
        });


        form.addEventListener('submit', (e) => {

            e.preventDefault();

            setTimeout(()=> {
                this.modalForm(form);
            }, 0);
        });
    }

    modalForm(form) {
        if(form.matches(`.${this.inValidSelector}`)) return;

        const inputs = form.querySelectorAll(`.${this.modalFormInputSelector}`);
        const successSelector = document.querySelector(`.${this.sendSuccessSelector}`);

        $.request('FeedbackModal::onSend', {
            form: form,
            loading: `.${this.preLoaderSelector}`,
            success: function (){
                successSelector.classList.add('modal__success_show');

                setTimeout(() => {
                    for (let input of inputs) {
                        input.value = '';
                        input.dispatchEvent(new Event('change', {
                            bubbles: true,
                        }));
                    }
                    MicroModal.close(this.modal);
                    successSelector.classList.remove('modal__success_show');
                }, 2000);
            }
        });
    }
}();
